export { CookieConsent } from "./CookieConsent";